// extracted by mini-css-extract-plugin
module.exports = {"container":"OrganisationForm_container__2IPdZ"};